import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '@services/api.service'
import { JobModel, jobUrl } from '@editor/store/slices/job.slice'
import { AxiosError } from 'axios'
import {toast} from 'react-toastify'

export interface createFromUrlProps {
  articleUrl: string
  voice: string
  template: string
  secondaryVoice: string | null
}

export interface ActualizeJobProps {
  jobId: string
  voice: string
  template: string
  secondaryVoice: string | null
}

export enum JOB_ORDERING_BY {
  updatedAt = 'updated_at',
  state = 'state',
}

export enum ORDERING {
  ascending = '',
  descending = '-',
}

export const createFromUrl = createAsyncThunk(
  'job/createFromUrl',
  async (props: createFromUrlProps, { rejectWithValue }) => {
    try {
      const response = await api.post(`/${jobUrl}/create/`, { ...props })
      let jobData = response.data
      if (response.status == 206) {
        toast.warning(response.data.message)
        jobData = response.data.data
      }
      return jobData as JobModel
    } catch (error: any) {
      if (error instanceof AxiosError && error?.response?.data?.message) {
        return rejectWithValue(error?.response?.data?.message)
      }
      return rejectWithValue('Došlo k nečekáné chybě')
    }
  }
)
export interface TextToAudioProps {
  ssml: string
  jobId: string
}
export const ssmlToAudio = createAsyncThunk(
  'job/ssml-to-audio/',
  async (props: TextToAudioProps, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/${jobUrl}/${props.jobId}/ssml-to-audio/`,
        {
          ssml: props.ssml,
        }
      )
      return response.data
    } catch (error: any) {
      if (error instanceof AxiosError && error?.response?.data?.message) {
        return rejectWithValue(error?.response?.data?.message)
      }
      return rejectWithValue('Došlo k nečekáné chybě')
    }
  }
)

// Type for filters
interface FetchParams {
  page?: number
  pageSize?: number
  searchInTitle?: string
  filterByUser?: string
  filterByState?: string
  order?: {
    orderBy: JOB_ORDERING_BY | string
    ordering: ORDERING | string
  }
}

// Define and export your async thunk
export const fetchAllJobsFiltered = createAsyncThunk(
  'jobs/fetchAllJobsFiltered',
  async ({
    page,
    pageSize,
    searchInTitle,
    filterByUser,
    filterByState,
    order,
  }: FetchParams = {}) => {
    let url = `${jobUrl}/`

    // Construct URL with query parameters only if they are not 'undefined'
    if (typeof page !== 'undefined') {
      url = url + `?offset=${page}`
    }

    if (typeof pageSize !== 'undefined') {
      url = url.includes('?')
        ? url + `&limit=${pageSize}`
        : url + `?limit=${pageSize}`
    }

    if (typeof searchInTitle !== 'undefined' && searchInTitle !== '') {
      url = url.includes('?')
        ? url + `&search=${searchInTitle}`
        : url + `?search=${searchInTitle}`
    }

    if (typeof filterByUser !== 'undefined' && filterByUser !== '') {
      url = url.includes('?')
        ? url + `&updated_by__username=${filterByUser}`
        : url + `?updated_by__username=${filterByUser}`
    }
    if (typeof filterByState !== 'undefined' && filterByState !== '') {
      url = url.includes('?')
        ? url + `&state=${filterByState}`
        : url + `?state=${filterByState}`
    }
    if (typeof order !== 'undefined' && order.orderBy !== undefined) {
      url = url.includes('?')
        ? url + `&ordering=${order.ordering}${order.orderBy}`
        : url + `?ordering=${order.ordering}${order.orderBy}`
    }

    const response = await api.get(url)
    return response.data.results
  }
)

export const actualizeJob = createAsyncThunk(
  'job/actualize',
  async (props: ActualizeJobProps, { rejectWithValue }) => {
    const { jobId, voice, template, secondaryVoice } = props
    try {
      const response = await api.get(`/${jobUrl}/${jobId}/actualize/`, {
        params: { voice, template, secondaryVoice },
      })
      let jobData = response.data
      if (response.status == 206) {
        toast.warning(response.data.message)
        jobData = response.data.data
      }
      return jobData as JobModel
    } catch (error: any) {
      if (error instanceof AxiosError && error?.response?.data?.message) {
        return rejectWithValue(error?.response?.data?.message)
      }
      return rejectWithValue('Došlo k nečekáné chybě')
    }
  }
)
